(() => {
  const promoMarkup = `
    <div class="dos-feature-menu__promos" aria-label="Featured Dawterson picks">
      <a class="dos-feature-menu__promo" href="/products/sterling-silver-teardrop-moissanite-pendant-necklace">
        <span class="dos-feature-menu__image-wrap"><img class="dos-feature-menu__image" src="https://cdn.shopify.com/s/files/1/0952/6142/5974/files/sterling-silver-teardrop-main-cream.png?v=1789048534" alt="Sterling Silver Teardrop Moissanite Pendant Necklace"></span>
        <span class="dos-feature-menu__caption">Sterling Silver Teardrop Pendant</span>
      </a>
      <a class="dos-feature-menu__promo" href="/products/radiant-lift-4-in-1-facial-neck-massager">
        <span class="dos-feature-menu__image-wrap"><img class="dos-feature-menu__image" src="https://cdn.shopify.com/s/files/1/0952/6142/5974/files/radiant-lift-hero-lifestyle.png?v=1788959883" alt="4-in-1 Facial and Neck Massager"></span>
        <span class="dos-feature-menu__caption">4-in-1 Facial &amp; Neck Massager</span>
      </a>
      <div class="dos-feature-menu__promo dos-feature-menu__promo--static" aria-label="Portable Cordless Tire Inflator">
        <span class="dos-feature-menu__image-wrap"><img class="dos-feature-menu__image" src="https://cdn.shopify.com/s/files/1/0952/6142/5974/files/cordless-inflator-ready-when-you-are-hero.png?v=1788874458" alt="Portable Cordless Tire Inflator"></span>
        <span class="dos-feature-menu__caption">Portable Cordless Tire Inflator</span>
      </div>
    </div>`;

  const catalogLinks = `
    <nav class="dos-feature-menu__links dos-feature-menu__links--catalog" aria-label="Catalog collections">
      <a href="/collections/socks">Socks</a><a href="/collections/elevate-your-everyday-the-modern-jewelry-collection">Jewelry</a><a href="/collections/trending-best-selling-favorites">Best sellers</a><a href="/collections/the-perfect-finishing-touch">Accessories</a><a href="/collections/naturally-well">Health</a><a href="/collections/fitness-support">Fitness &amp; Support</a><a href="/collections/outerwear">Outerwear</a><a href="/collections/pets">Pet Supplies</a><a href="/collections/the-problem-solver-room">Problem Solver Products</a>
    </nav>`;

  function enhanceCatalog() {
    document.querySelectorAll('.menu-list__link-title').forEach((label) => {
      if (label.textContent.trim() !== 'Catalog') return;
      const item = label.closest('.menu-list__list-item');
      const grid = item?.querySelector('.mega-menu__grid');
      if (!grid || grid.dataset.dosCatalogReady === 'true') return;
      grid.dataset.dosCatalogReady = 'true';
      grid.classList.add('dos-feature-menu','dos-feature-menu--catalog');
      grid.innerHTML = `<div class="dos-feature-menu__left">${catalogLinks}</div>${promoMarkup}`;
    });
  }

  const start = () => {
    enhanceCatalog();
    new MutationObserver(() => requestAnimationFrame(enhanceCatalog)).observe(document.documentElement,{childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();